// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__G1rRM","question":"Question_question__gYrjl","description":"Question_description__3hX3L"};